import { hasProtocol } from '@lumapps/utils/string/isUrl';

/**
 * Add the current window origin to a URL that has no protocol.
 * @param url - URL to complete.
 * @returns an absolute URL.
 */
export const addLocationOriginToUrl = (url: string) => (hasProtocol(url) ? url : window.location.origin + url);
